import ChatLandingPage from "./ChatLandingPage";
const ChatHome = () =>{
    return (
        <div>       
            <ChatLandingPage></ChatLandingPage>
        </div>
    )
}

export default ChatHome;